module.exports = __webpack_public_path__ + "r-v3/img/translation_EN.c35f3f8f.png";